import React from 'react';
import * as styles from './InaccessibleMentionNotice.module.scss';
import SVGIcon from '../../components/SVGIcon';
import secretIcon from '../../icons/non-prefilled/16x16/secret.svg';

interface InaccessibleMentionNoticeProps {
  mention: 'topic' | 'post';
}

const InaccessibleMentionNotice = ({
  mention,
}: InaccessibleMentionNoticeProps) => {
  return (
    <div className={styles.error}>
      <div className={styles.icon}>
        <SVGIcon size={24}>{secretIcon}</SVGIcon>
      </div>
      <div className={styles.title}>Inaccessible {mention}</div>
      <div>You do not have access to this {mention}.</div>
    </div>
  );
};

export default InaccessibleMentionNotice;
